<template>
  <div :class="[$style.container, settings && settings.reversed ? $style.reversed : '' ]">
    <div :class="[$style.text]">
      <TextBlock
        :reversed="settings && settings.reversed ? settings.reversed : false"
        :content="content.text"
        :title="content.title" />
    </div>
    <ul :class="$style.iconsList">
      <li v-for="(image, index) in content.images" :key="image">
        <BigIcon
        :class="[
          $style.image,
          index === 2 ? $style.last : false,
          $route.name === 'fitness' ? index === 0 ? $style.sleep : $style.bigger : ''
        ]"
        :index="index"
        :src="image" />
      </li>
    </ul>
  </div>
</template>

<script>
import TextBlock from '@/components/TextBlock'
import BigIcon from '@/components/BigIcon'

export default {
  props: ['content', 'settings'],

  components: {
    TextBlock,
    BigIcon
  }
}
</script>

<style lang="scss" module>
@import "~sass-mq/mq";

.text {
  width: 100%;
  flex: 0 1 auto;

  @include mq(sm) {
    width: 45%;
  }

  @include mq(ds) {
    width: 30%;
  }
}

.container {
  @include grid-size();
  display: flex;
  flex-flow: column;
  align-items: center;
  padding: $big-margin-mobile;

  @include mq(sm) {
    flex-flow: row;
    justify-content: space-between;
    padding: $big-margin;

    &.reversed {
      flex-flow: row-reverse;
    }
  }

}

.iconsList {
  display: flex;
  width: 100%;
  flex: 0 0 100%;
  justify-content: space-between;
  align-items: center;
  margin-top: 30px;

  @include mq(sm) {
    width: 45%;
    flex: 0 0 45%;
    justify-content: space-between;
    margin-top: 0;
  }

  @include mq(ds) {
    width: 60%;
    flex: 0 0 60%;
  }

  li {
    padding: $small-margin-mobile * 2 0px;

    flex-basis: 33.33%;
    max-width: 33.33%;

    @include mq(sm) {
      flex-basis: auto;
      max-width: none;
    }

    @include mq(sm) {
      padding: $small-margin-mobile;
    }
  }

  .image {
  margin: 0 auto;
  width: 30px;
  padding: 0;

  @include mq(sm) {
    width: 80px;
    height: 80px;
  }

    &.last {
      width: 45px;

      @include mq(sm) {
        width: 80px;
        height: 80px;
      }

      @include mq(md) {
        width: 90px;
        height: 90px;
      }
    }

    &.bigger {
      width: 45px;

      @include mq(sm) {
        width: 80px;
        height: 80px;
      }

      @include mq(md) {
        width: 90px;
        height: 90px;
      }
    }

    &.sleep {
      width: 40px;

      @include mq(sm) {
        width: 70px;
        height: 70px;
      }

      @include mq(md) {
        width: 85px;
        height: 85px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/InfoBlock.vue